import Vue from 'vue';
import Router from 'vue-router';
import Authorization from '@/views/Authorization/Index.vue';
import EmailLogin from '@/views/Authorization/EmailLogin';
import DashboardIndex from '@/views/Dashboard/Index';
import ObjectsView from '@/views/Dashboard/Objects/Index';
import DirsView from '@/views/Dashboard/Dirs/Index';


import ProjectEdit from '@/views/Dashboard/Projects/Edit';
import AuthHandler from '@/views/Authorization/AuthHandler';
import ResetPassword from '@/views/Authorization/ResetPassword';
import JobsList from '@/views/Dashboard/Jobs/List';
import JobsCreate from '@/views/Dashboard/Jobs/Create';
import MaterialsCreate from '@/views/Dashboard/Jobs/Materials';

import ProjectsList from '@/views/Dashboard/Projects/List';
import ProfileEdit from '@/views/Dashboard/Profile/Edit';
import InfoView from '@/views/Dashboard/Info/Index';
import UsersView from '@/views/Dashboard/Users/List';
import UsersCreate from '@/views/Dashboard/Users/Create';
import UsersEdit from '@/views/Dashboard/Users/Edit';
import ReportsView from '@/views/Dashboard/Reports/Index';
import ReportsViewType from '@/views/Dashboard/Reports/Type';
import ReportsViewTypeTabel from '@/views/Dashboard/Reports/TypeTabel';

import JobsReport from '@/views/Dashboard/Reports/JobsReport';
import JobsReportObjects from '@/views/Dashboard/Objects/JobsReportObjects';
import ReportsCreate from '@/views/Dashboard/Reports/Create';
import ReportsCreateTabel from '@/views/Dashboard/Reports/CreateTabel';
import ClientList from '@/views/Admin/Clients/List';
import SelectUsers from '../views/Dashboard/Users/SelectUsers';
import WorkType from  '../views/Dashboard/WorkType/Index';
import WorkTypeCreate from '../views/Dashboard/WorkType/Create';
import WorkTypeEdit from '../views/Dashboard/WorkType/Create';
import WorkSection from '../views/Dashboard/Projects/WorkSection';
import AnalyticsView from '@/views/Dashboard/Analytics/List';
import AnalyticsViewType from '@/views/Dashboard/Analytics/Type';
import ConstructionEngineering from '@/views/Dashboard/Analytics/ConstructionEngineering';
import Performance from '@/views/Dashboard/Analytics/Performance';
import Welding from '@/views/Dashboard/Analytics/Welding';
import AnalyticsIndex from '@/views/Dashboard/Analytics/Index';
import ClientInfo from '../views/Admin/Clients/ClientInfo';
import AnalyticsJob from '@/views/Dashboard/Analytics/Job'
import AnalyticsJobPrice from '@/views/Dashboard/Analytics/JobPrice'
import DocumentationEdit from '@/views/Dashboard/Documentation/Edit'
import FilesView from '@/views/Dashboard/Files/List';
import FilesCreate from '@/views/Dashboard/Files/Create';
import DocsView from '@/views/Dashboard/Files/Index';
import AnalyticsProgressView from '@/views/Dashboard/Analytics/Progress';
import AnalyticsPopulationView from '@/views/Dashboard/Analytics/Population';

import AnalyticsProgressWorkView from '@/views/Dashboard/Analytics/ProgressWork';
import AnalyticsPlanWork from '@/views/Dashboard/Analytics/ProgressPlanWork';
import AnalyticsSummaryView from '@/views/Dashboard/Analytics/Summary';
import AnalyticsChessVolume from '@/views/Dashboard/Analytics/ChessVolume'

import UnitList from '../views/Dashboard/Unit/Index';
import UnitCreate from '../views/Dashboard/Unit/Create';
import JoinList from '../views/Dashboard/Join/Index';
import JoinCreate from '../views/Dashboard/Join/Create';

import PlanList from '../views/Dashboard/Plan/Index';
import PlanCreate from '../views/Dashboard/Plan/Create';
import PlanUsers from '../views/Dashboard/Plan/Users';
import PlanEdit from '../views/Dashboard/Plan/Edit';

import TasksList from '../views/Dashboard/Tasks/List';
import TasksCreate from '../views/Dashboard/Tasks/Create';
import TasksCategoriesList from '../views/Dashboard/Tasks/Categories/List';
import TasksCategoriesCreate from '../views/Dashboard/Tasks/Categories/Create';
import WorkordersCategoriesList from '../views/Dashboard/Workorder/Categories/List';
import WorkordersCategoriesCreate from '../views/Dashboard/Workorder/Categories/Create';
import TasksIndex from '../views/Dashboard/Tasks/Index';

import InputsList from '../views/Dashboard/Inputs/Index';
import InputsCreate from '../views/Dashboard/Inputs/Create';
import InputsDirs from '../views/Dashboard/Inputs/Dirs'
import InputsDirsJobs from '../views/Dashboard/Inputs/DirsJobs'
import InputsDirsJobsShow from '../views/Dashboard/Inputs/DirsJobsDesktopShow'

import Zones from '../views/Dashboard/Inputs/Zone/Index'

import VersionsList from '@/views/Dashboard/Versions/Index';
import VersionsCreate from '@/views/Dashboard/Versions/Create';
import VersionsEdit from '@/views/Dashboard/Versions/Edit';
import VersionsUsers from '../views/Dashboard/Versions/Users';

import CompanyUsersList from '@/views/Dashboard/Users/company/UsersList.vue'
import CompanyUsersCreate from '@/views/Dashboard/Users/company/UsersCreate'
import AnalyticsPopulationMain from '@/views/Dashboard/Analytics/PopulationMain';
import AnalyticsSCurve from '../views/Dashboard/Analytics/CurveS';
import TasksMenu from '../views/Dashboard/Tasks/Index'

import WorkOrderSettings from '@/views/Dashboard/Workorder/Settings'
import ReportsOneSettings from '../views/Dashboard/ReportsOne/Settings'

import WorkordersList from '../views/Dashboard/Workorder/List'
import WorkordersCreate from '../views/Dashboard/Workorder/Create'


import OneReportList from '../views/Dashboard/ReportsOne/List'
import OneReportCreate from '../views/Dashboard/ReportsOne/Create'
Vue.use(Router);

export default [
  {
    path: '/',
    name: 'Authorization-index',
    component: Authorization,
    meta: {
      guest: true,
    },
  },
  {
    path: '/auth',
    name: 'Authorization-handler',
    component: AuthHandler,
  },
  {
    path: '/sign/resetPassword/:code',
    name: 'Authorization-reset-password',
    component: ResetPassword,
    meta: {
      guest: true,
    },
  },
  {
    path: '/registration',
    name: 'Authorization-email-login',
    component: EmailLogin,
    meta: {
      guest: true,
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard.index',
    component: DashboardIndex,
    meta: {
      auth: true,
    },
    children: [
      {
        path: 'versions',
        name: 'versions-list',
        component: VersionsList,
      },
      {
        path: 'workorders',
        name: 'work-orders',
        component: WorkOrderSettings,
      },
      {
        path: 'report-one-settings',
        name: 'report-one-settings',
        component:  ReportsOneSettings
      },
      {
        path: 'tasks-menu',
        name: 'tasks-menu',
        component: TasksMenu,
      },
      {
        path: 'jobs-report',
        name: 'jobs-report',
        component: JobsReport,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'jobs-report-obj',
        name: 'jobs-report-obj',
        component: JobsReportObjects,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'workorders-reports',
        name: 'work-orders-list',
        component: WorkordersList,
      },
      {
        path: 'workorders-reports/create',
        name: 'work-orders-create',
        component: WorkordersCreate,
        meta: {
          isBack: true,
        },
      },


      {
        path: 'one-reports',
        name: 'one-reports-list',
        component: OneReportList,
      },
      {
        path: 'one-reports/create',
        name: 'one-reports-create',
        component: OneReportCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'one-reports/create/:id',
        name: 'one-reports-update',
        component: OneReportCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'one-reports/create/:id/copy',
        name: 'onereportsCopy',
        component: OneReportCreate,
        meta: {
          isBack: true,
        },
      },


      {
        path: 'workorders-reports/create/:id',
        name: 'work-orders-edit',
        component: WorkordersCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'workorders-reports/create/:id/copy',
        name: 'workorderCopy',
        component: WorkordersCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'workorders/categories',
        name: 'work-orders-categories',
        component: WorkordersCategoriesList,
      },
      {
        path: 'workorders/categories',
        name: 'workorders-categories',
        component: TasksCategoriesList,
      },
      {
        path: 'workorders/categories/create/:id?',
        name: 'workorders-categories-create',
        component: WorkordersCategoriesCreate,
      },
      {
        path: 'company/users/:id',
        name: 'company-users-list',
        component: CompanyUsersList,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'company/users/create/:id',
        name: 'company-users-create',
        component: CompanyUsersCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'company/users/edit/:id/:userId',
        name: 'company-users-edit',
        component: CompanyUsersCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'versions/create',
        name: 'versions-create',
        component: VersionsCreate,
      },
      {
        path: 'versions/:id/edit',
        name: 'versions-edit',
        component: VersionsEdit,
      },
      {
        path: '/',
        name: 'infoView',
        component: InfoView,
      },
      {
        path: 'tasks',
        name: 'tasks',
        component: TasksList,
      },
      {
        path: 'tasksMenu',
        name: 'tasksMenu',
        component: TasksIndex,
      },
      {
        path: 'tasks/create/:id?',
        name: 'tasks-create',
        component: TasksCreate,
      },
      {
        path: 'tasks/categories',
        name: 'tasks-categories',
        component: TasksCategoriesList,
      },
      {
        path: 'tasks/categories/create/:id?',
        name: 'tasks-categories-create',
        component: TasksCategoriesCreate,
      },
      {
        path: 'tasks/create/:id/copy',
        name: 'tasksCopy',
        component: TasksCreate,
      },
      {
        path: 'documentation/edit',
        name: 'DocumentationEdit',
        component: DocumentationEdit,
      },
      {
        path: 'files/:id?',
        name: 'Files',
        component: FilesView,
      },
      {
        path: 'files/:id/edit/:type?',
        name: 'FilesEdit',
        component: FilesCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'docs',
        name: 'Docs',
        component: DocsView,
      },
      {
        path: 'files/:id/create/:type?',
        name: 'FileCreate',
        component: FilesCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'unit',
        name: 'unit',
        component: UnitList,
      },
      {
        path: 'unit/:id/edit',
        name: 'unit-edit',
        component: UnitCreate,
      },
      {
        path: 'unit/create',
        name: 'unit-create',
        component: UnitCreate,
      },

      {
        path: 'plan',
        name: 'plan',
        component: PlanList,
      },
      {
        path: 'plan/:id/edit',
        name: 'plan-edit',
        component: PlanEdit,
      },
      {
        path: 'plan/create',
        name: 'plan-create',
        component: PlanCreate,
      },
      {
        path: 'plan/users/:id',
        name: 'plan-users',
        component: PlanUsers,
      },

      {
        path: 'versions/users/:id',
        name: 'version-users',
        component: VersionsUsers,
      },

      {
        path: 'inch',
        name: 'inch',
        component: JoinList,
      },
      {
        path: 'inch/:id/edit',
        name: 'inch-edit',
        component: JoinCreate,
      },
      {
        path: 'inch/create',
        name: 'inch-create',
        component: JoinCreate,
      },
      {
        path: 'clients',
        name: 'admin',
        component: ClientList,
        meta: {
          auth: true,
          title: 'Список клиентов',
        },
      },
      {
        path: 'clients/:id',
        name: 'admin.client',
        component: ClientInfo,
        meta: {
          auth: true,
          title: 'Информация о клиенте по его созданым проектам',
        },
      },
      {
        path: 'objects',
        name: 'objects',
        component: ObjectsView,
      },
      {
        path: 'users',
        name: 'users',
        component: UsersView,
      },
      {
        path: 'analytics',
        name: 'analytics',
        component: AnalyticsIndex,
      },
      {
        path: 'reports',
        name: 'reports',
        component: ReportsView,
      },
      {
        path: 'dirs',
        name: 'dirs',
        component: DirsView,
      },
      {
        path: 'work_section',
        name: 'work-section',
        component: WorkSection,
        meta: {
          isBack: true,
          title: 'Настройки по разделам работ',
        },
      },
      {
        path: 'inputs',
        name: 'inputs',
        component: InputsList,
        meta: {
          isBack: true,
          title: 'Настройка полей',
        },
      },
      {
        path: 'zones',
        name: 'inputs-zones',
        component: Zones,
        meta: {
          isBack: true,
          title: 'Зона работ',
        },
      },
      {
        path: 'inputs/create',
        name: 'inputs-create',
        component: InputsCreate,
        meta: {
          isBack: true,
          title: 'Настройка полей',
        },
      },
      {
        path: 'inputs/:id/edit',
        name: 'inputs-edit',
        component: InputsCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: '/dashboard/obj/:id/inputs-show',
        name: 'inputs-obj-show',
        component: InputsDirsJobsShow,
        meta: {
          isBack: true,
        },
      },
      {
        path: '/dashboard/obj/:id/inputs',
        name: 'inputs-obj',
        component: InputsDirsJobs,
        meta: {
          isBack: true,
        },
      },

      {
        path: '/dashboard/dir/:id/inputs',
        name: 'inputs-dirs',
        component: InputsDirs,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'works/list/:type?',
        name: 'work-type',
        component: WorkType,
        meta: {
          isBack: true,
          title: 'Типы работ',
          replacedType: true,
        },
      },
      {
        path: 'works/create/:type?',
        name: 'work-type-create',
        component: WorkTypeCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'works/edit/:id/:type?',
        name: 'work-type-edit',
        component: WorkTypeEdit,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'reports/TABEL',
        name: 'reports-type-tabel',
        component: ReportsViewTypeTabel,
      },
      {
        path: 'reports/:type',
        name: 'reports-type-list',
        component: ReportsViewType,
      },
      {
        path: 'analytics/summary',
        name: 'analytics-summary',
        component: AnalyticsSummaryView,
      },
      {
        path: 'analytics/chess-volume',
        name: 'analytics-chess-volume',
        meta: {
          isBack: true,
          title: 'Шахматка - физобъемы'
        },
        component: AnalyticsChessVolume,
      },
      {
        path: 'analytics/plan',
        name: 'analytics-plan-list',
        component: AnalyticsView,
      },
      {
        path: 'analytics/work',
        name: 'analytics-plan-work',
        meta: {
          isBack: true,
          title: 'Производительность (трудоемкость)'
        },
        component: AnalyticsPlanWork,
      },
      {
        path: 'analytics/progress',
        name: 'analytics-progress',
        component: AnalyticsProgressView,
        meta: {
          isBack: true,
          isProgress: true,
          title: 'Прогресс - '
        }
      },
      {
        path: 'analytics/population',
        name: 'analytics-population',
        component: AnalyticsPopulationView,
        meta: {
          isBack: true,
          title: 'Численность'
        }
      },
      {
        path: 'analytics/population-main',
        name: 'analytics-population-main',
        component: AnalyticsPopulationMain,
        meta: {
          isBack: true,
          title: 'Численность'
        }
      },
      {
        path: 'analytics/s-curve',
        name: 'analytics-s-curve',
        component: AnalyticsSCurve,
        meta: {
          isBack: true,
          title: 'S - кривая'
        }
      },
      {
        path: 'analytics/progress-work',
        name: 'analytics-progress-work',
        meta: {
          isBack: true,
          title: 'Прогресс (трудоемкость)'
        },
        component: AnalyticsProgressWorkView,
      },
      {
        path: 'analytics/job',
        name: 'analytics-job-list',
        component: AnalyticsJob,
      },
      {
        path: 'analytics/job-price',
        name: 'analytics-job-price-list',
        component: AnalyticsJobPrice,
      },
      {
        path: 'analytics/construction-engineering',
        name: 'construction-engineering',
        component: ConstructionEngineering
      },
      {
        path: 'analytics/performance',
        name: 'performance',
        component: Performance
      },
      {
        path: 'analytics/welding',
        name: 'welding',
        component: Welding
      },
      {
        path: 'analytics/amount',
        name: 'analytics-type-list',
        component: AnalyticsViewType,
      },
      {
        path: 'reports/create/TABEL',
        name: 'reportsCreateTable',
        component: ReportsCreateTabel,
      },
      {
        path: 'reports/create/:type',
        name: 'reportsCreate',
        component: ReportsCreate,
      },
      {
        path: 'reports/create/:id/TABEL',
        name: 'reportsCreateTable.id',
        component: ReportsCreateTabel,
      },
      {
        path: 'reports/create/:id/:type',
        name: 'reportsCreate.id',
        component: ReportsCreate,
      },
      {
        path: 'reports/create/:id/:type/copy',
        name: 'reportsCopy',
        component: ReportsCreate,
      },
      {
        path: 'users/create',
        name: 'usersCreate',
        component: UsersCreate,
      },
      {
        path: 'users/create/:company',
        name: 'usersCreateCompany',
        component: UsersCreate,
      },
      {
        path: 'users/project',
        name: 'usersProject',
        component: ProjectsList,
      },
      {
        path: 'users/project/:id',
        name: 'selectUsers',
        component: SelectUsers,
      },
      {
        path: 'users/edit/:id',
        name: 'usersEdit',
        component: UsersEdit,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'settings',
        component: ProjectEdit,
      },
      {
        path: 'projects',
        component: ProjectsList,
      },
      {
        path: 'profile',
        name: 'profile.edit',
        component: ProfileEdit,
      },
      {
        path: 'jobs/:id?',
        name: 'JOB',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Работы',
        },
      },

      {
        path: 'jobs/:id/edit/:type?',
        name: 'JobEdit',
        component: JobsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'jobs/:id/create/:type?',
        name: 'jobCreate',
        component: JobsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'materials/create',
        name: 'materialsCreate',
        component: MaterialsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'materials/:id/edit',
        name: 'MaterialsEdit',
        component: MaterialsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'tech',
        name: 'TECH',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Техника',
        },
      },


      {
        path: 'prof',
        name: 'PROF',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Профессии',
        },
      },

      {
        path: 'materials',
        name: 'MATERIALS',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Материалы',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/index.js